import { render, staticRenderFns } from "./AdvAuthorization.vue?vue&type=template&id=23ea61d5&"
import script from "./AdvAuthorization.vue?vue&type=script&lang=js&"
export * from "./AdvAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports